<template>
  <section class="py-5 bg-light bg-bg-1">
    <div class="container my-0 my-lg-5">
      <div class="row">
        <div class="col-12 mb-5 fade-in-item right">
          <div class="f-xmlg bld">Property Highlights</div>
          <div class="bar-short mt-3"></div>
        </div>
        <div class="col-12 col-md-4 mb-4 mb-md-0 fade-in-item right">
          <div class="f-xlg lbld mb-3">Fabulous Views</div>
          <div class="l-op f-lg lh-lg">
            Take in the breathtaking scenery offered by Mountain View. Enjoy the
            fabulous vistas this beautiful location has to offer.
          </div>
        </div>
        <div class="col-12 col-md-4 mb-4 mb-md-0 fade-in-item up">
          <div class="f-xlg lbld mb-3">Quiet Neighborhood</div>
          <div class="l-op f-lg lh-lg">
            Experience the peace and tranquility of a new and burgeoning
            neighborhood. Relish the quiet atmosphere as the community continues
            to grow and develop.
          </div>
        </div>
        <div class="col-12 col-md-4 fade-in-item left">
          <div class="f-xlg lbld mb-3">Local Amenities</div>
          <div class="l-op f-lg lh-lg">
            Paved and unpaved running, hiking, biking, and off-leash dog trails.
            A new reservoir coming soon.
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  data() {
    return {};
  },
};
</script>

<style>
.bg-bg-1 {
  background-image: url("https://cdn.pixilart.com/admin/files/31e68f5eceb0731.png");
  background-size: cover;
  background-position: center;
}
</style>
